// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__HXZWL","label":"Tooltip_label__Drbwj","arrow":"Tooltip_arrow__BhZIn"};